module.exports = __webpack_public_path__ + "f325923f66c519a540774b6267c6f6ad.svg";